// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H14V10H22V22H16V16H14V22H2V2ZM8 10H12V4H4V20H8V10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-7-filled')
export default class City7FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-7-filled',
    }
  }
}
